import React from 'react';
import { breakpoints } from 'styles';

interface Props {
  children: React.ReactNode;
  withSidebar?: boolean;
}

const PageContent = ({ children, withSidebar }: Props) => (
  <div className="container">
    <div className={`page-content ${withSidebar ? 'with-sidebar' : ''}`}>
      {children}
    </div>

    <style jsx>{`
      .page-content {
        flex-grow: 1;
        padding: 20px 0 70px;
        width: 100%;
      }
      @media (min-width: ${breakpoints.medium}px) {
        .page-content.with-sidebar {
          align-items: flex-start;
          display: flex;
        }
      }
    `}</style>
  </div>
);

export default PageContent;
